import React from 'react';
import LongRead from './LongRead';

export default function LongReadsList({list}) {
  if (!list) {return "Error: no long reads list provided";}
  return <div className="long-read-list">
    {list.map((lr, i) => <LongRead data={lr} key={i} listItem />)}
  </div>;
};
